import { render, staticRenderFns } from "./Users_salaries.vue?vue&type=template&id=127b453f&scoped=true&lang=pug&"
import script from "./Users_salaries.vue?vue&type=script&lang=coffee&"
export * from "./Users_salaries.vue?vue&type=script&lang=coffee&"
import style0 from "./Users_salaries.vue?vue&type=style&index=0&id=127b453f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127b453f",
  null
  
)

export default component.exports